import { render, staticRenderFns } from "./addCRMcase.vue?vue&type=template&id=4ea9b570"
import script from "./addCRMcase.vue?vue&type=script&lang=js"
export * from "./addCRMcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports